export var ItemCardType;
(function (ItemCardType) {
    ItemCardType[ItemCardType["Recipe"] = 0] = "Recipe";
    ItemCardType[ItemCardType["Product"] = 10] = "Product";
})(ItemCardType || (ItemCardType = {}));
export var ItemCardText;
(function (ItemCardText) {
    ItemCardText["SUBSCRIBE"] = "Subscribe";
    ItemCardText["CUSTOMIZE"] = "Customize";
})(ItemCardText || (ItemCardText = {}));
